module.exports = __webpack_public_path__ + "img/WhatsApp Image 2019-10-11 at 1.02.43 PM (21).c3828f56.jpeg";